<template>
  <div style="padding: 0 10px">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane v-for="item in comList" :key="item.name" :label="item.title" :name="item.name">
        <div style="border: 1px solid #E4E7ED;border-top: none; padding: 10px;border-radius: 0 0 6px 6px">
          <component :is="item.name" :name="item.name" v-if="activeName == item.name"/>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import sheet from './sheet'
import washLabel from './washLabel'

export default {
  name: "printerConfig", // 国际发货单列表
  components: {
    sheet,
    washLabel
  },
  data() {
    return {
      activeName: sheet.name
    }
  },
  computed: {
    comList: function () {
      return [sheet,washLabel]
    }
  }
}
</script>

<style scoped>
::v-deep .el-tabs__header {
  margin-bottom: 0px !important;
}
</style>